import "%modules%/header/header";
import "%modules%/footer/footer";
import "%modules%/contacts/contacts";
import "%modules%/case-content/case-content";
import "%modules%/new-projects/new-projects";
import "%modules%/modal/modal";